import { useEffect } from "react";
import { ThemeProvider, applyThemeClass, getStoredTheme } from "@wombat/ui-kit";

// contexts
import { AuthenticationProvider } from "./authentication/authentication.context";
import { ReactQueryProvider } from "./react-query/react-query.context";
import { DataStoreProvider, emptyStoreState } from "./dataStore.context";
import { LanguageProvider } from "./language.provider";
import { ToastProvider } from "./toast.context";
import { ConnectivityStatusProvider } from "./connectivity.context";

/*
 * HOC for cleaning up Context Provider imports
 */
const AllContexts: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isDark =
    getStoredTheme() === "dark" && window.frameElement?.id !== "formPdf";
  const theme = isDark ? "dark" : "light";

  const language = localStorage.getItem("language") || "en";

  useEffect(() => {
    applyThemeClass(theme);
  }, [theme]);

  return (
    <ReactQueryProvider>
      <ConnectivityStatusProvider>
        <DataStoreProvider
          initialData={JSON.parse(JSON.stringify(emptyStoreState))}
        >
          <ThemeProvider
            initialValues={{
              theme: theme,
            }}
          >
            <LanguageProvider
              initialValues={{
                language: language,
              }}
            >
              <ToastProvider>
                <AuthenticationProvider>{children}</AuthenticationProvider>
              </ToastProvider>
            </LanguageProvider>
          </ThemeProvider>
        </DataStoreProvider>
      </ConnectivityStatusProvider>
    </ReactQueryProvider>
  );
};

export default AllContexts;
